// import React, { useState, useEffect } from 'react';
// import { toast } from 'react-toastify'; 
// import EmployeeForm from './form';
// import { Deletemodel } from '../../Common/Functions';  
// import { getEmployees, deleteEmployee } from '../../../Utility/Api'; 

// const EmployeeList = () => {

//   const [employees, setEmployees] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [deleteModal, setDeleteModal] = useState(false);
//   const [deleteID, setDeleteID] = useState('');
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);

//   useEffect(() => {
//     fetchEmployees();
//   }, []);

//   const fetchEmployees = async () => {
//     try {
//       const response = await getEmployees();
//       if (response.data && response.data.data) {
//         setEmployees(response.data.data);
//       } else {
//         toast.error('No employees found.');
//       }
//     } catch (error) {
//       console.error('Error fetching employees:', error);
//       toast.error('Error fetching employees');
//     }
//   };

//   const openModal = (employee = null) => {
//     setSelectedEmployee(employee);
//     setShowModal(true);
//   };

//   const handleDelete = async () => {
//     try {
//       await deleteEmployee(deleteID);  
//       toast.success('Employee deleted successfully');
//       fetchEmployees(); 
//       setDeleteModal(false);
//     } catch (error) {
//       console.error('Error deleting employee:', error);
//       toast.error('Error deleting employee');
//     }
//   };

//   return (
//     <div className="page-wrappers">
//       <div className="page-content">
//         <h6 className="mb-0 text-uppercase">Employee List</h6>
//         <hr />
//         <button type="button" onClick={() => openModal()} className="btn btn-primary mb-2" style={{ fontFamily: 'poppins' }}>
//           Add Employee
//         </button>
//         <div className="card">
//           <div className="card-body">
//             <div className="table-responsive">
//               <table className="table table-striped table-sm table-bordered align-baseline" style={{ width: '100%', fontFamily: 'poppins' }}>
//                 <thead>
//                   <tr>
//                     <th>S.No</th>
//                     <th>Name</th>
//                     <th>Role</th>
//                     <th>Shop</th>
//                     <th>Branch</th>
//                     <th>Salary</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {employees.map((employee, index) => (
//                     <tr key={employee.id}>
//                       <td>{(currentPage - 1) * employees + index + 1}</td>
//                       <td>{employee.name}</td>
//                       <td>{employee.role}</td>
//                       <td>{employee.shop}</td>
//                       <td>{employee.branch}</td>
//                       <td>{employee.salary}</td>
//                       <td>
//                         <img
//                           src='/assets/images/icons/edit.png'
//                           onClick={() => openModal(employee)}
//                           height="20px"
//                           alt="Edit"
//                         />
//                         <img
//                           src='/assets/images/icons/delete.png'
//                           className="mx-1"
//                           onClick={() => {
//                             setDeleteID(employee.id);
//                             setDeleteModal(true);
//                           }}
//                           height="20px"
//                           alt="Delete"
//                         />
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>

//       {deleteModal && (
//         <Deletemodel
//           setShowModal={setDeleteModal}
//           handleDelete={handleDelete}
//         />
//       )}

//       {showModal && (
//         <EmployeeForm
//           employee={selectedEmployee}
//           closeModal={() => setShowModal(false)}
//         refreshList={fetchEmployees}
//         />
//       )}
//     </div>
//   );
// };

// export default EmployeeList;
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify'; 
import EmployeeForm from './form';
import { Deletemodel } from '../../Common/Functions';  
import { NaviGate } from '../../../Utility/function';
// No need for getEmployees import for now
// import { getEmployees, deleteEmployee } from '../../../Utility/Api'; 

const EmployeeList = () => {

  const [employees, setEmployees] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteID, setDeleteID] = useState('');
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  // Use dummy data for now
  useEffect(() => {
    fetchEmployees(); 
  }, []);

  const fetchEmployees = () => {
    // Dummy employee data
    const dummyData = [
      { id: 1, name: 'John Doe', role: 'Manager', shop: 'Shop 1', branch: 'Branch A', salary: '5000' },
      { id: 2, name: 'Jane Smith', role: 'Assistant', shop: 'Shop 2', branch: 'Branch B', salary: '3000' },
      { id: 3, name: 'Mike Johnson', role: 'Staff', shop: 'Shop 1', branch: 'Branch A', salary: '2000' },
      { id: 4, name: 'Sara Lee', role: 'Manager', shop: 'Shop 3', branch: 'Branch C', salary: '5500' },
    ];

    // Simulate API response
    setEmployees(dummyData);
  };

  const openModal = (employee = null) => {
    setSelectedEmployee(employee);
    setShowModal(true);
  };

  const handleDelete = () => {
    // Simulate employee deletion
    const updatedEmployees = employees.filter(employee => employee.id !== deleteID);
    setEmployees(updatedEmployees);
    toast.success('Employee deleted successfully');
    setDeleteModal(false);
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
      <NaviGate />
        <h6 className="mb-0 text-uppercase">Employee List</h6>
        <hr />
        <button type="button" onClick={() => openModal()} className="btn btn-primary mb-2" style={{ fontFamily: 'poppins' }}>
          Add Employee
        </button>
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-striped table-sm table-bordered align-baseline" style={{ width: '100%', fontFamily: 'poppins' }}>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Role</th>
                    <th>Shop</th>
                    <th>Branch</th>
                    <th>Salary</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {employees.map((employee, index) => (
                    <tr key={employee.id}>
                      <td>{(currentPage - 1) * employees.length + index + 1}</td>
                      <td>{employee.name}</td>
                      <td>{employee.role}</td>
                      <td>{employee.shop}</td>
                      <td>{employee.branch}</td>
                      <td>{employee.salary}</td>
                      <td>
                        <img
                          src='/assets/images/icons/edit.png'
                          onClick={() => openModal(employee)}
                          height="20px"
                          alt="Edit"
                        />
                        <img
                          src='/assets/images/icons/delete.png'
                          className="mx-1"
                          onClick={() => {
                            setDeleteID(employee.id);
                            setDeleteModal(true);
                          }}
                          height="20px"
                          alt="Delete"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {deleteModal && (
        <Deletemodel
          setShowModal={setDeleteModal}
          handleDelete={handleDelete}
        />
      )}

      {showModal && (
        <EmployeeForm
          employee={selectedEmployee}
          closeModal={() => setShowModal(false)}
          refreshList={fetchEmployees}
        />
      )}
    </div>
  );
};

export default EmployeeList;
